import {Demographics, FormValues} from "domain/types";

export const mapFormValuesToDemographics = (v: FormValues): Demographics => ({
    gender: v.sexo || "",
    ageRange: v.edad || "",
    maritalStatus: v.estadoCivil || "",
    occupation: v.ocupacionProfesionPuesto || "",
    department: v.departamentoSeccionArea || "",
    educationLevel: v.nivelEstudios || "",
    educationStatus: v.estadoNivelEstudios || "",
    positionType: v.tipoPuesto || "",
    contractType: v.tipoContratacion || "",
    personnelType: v.tipoPersonal || "",
    workSchedule: v.tipoJornada || "",
    hasShiftRotation: !!v.rotacionTurno,
    currentPositionExperience: v.antiguedad || "",
    totalWorkExperience: v.experienciaLaboral || "",
});

export const mapDemographicsToFormValues = (d: Demographics): FormValues => ({
    sexo: d.gender || "",
    edad: d.ageRange || "",
    estadoCivil: d.maritalStatus || "",
    ocupacionProfesionPuesto: d.occupation || "",
    departamentoSeccionArea: d.department || "",
    nivelEstudios: d.educationLevel || "",
    estadoNivelEstudios: d.educationStatus || "",
    tipoPuesto: d.positionType || "",
    tipoContratacion: d.contractType || "",
    tipoPersonal: d.personnelType || "",
    tipoJornada: d.workSchedule || "",
    rotacionTurno: d.hasShiftRotation,
    antiguedad: d.currentPositionExperience || "",
    experienciaLaboral: d.totalWorkExperience || "",
});
